import { parseISO } from 'date-fns';
import { z } from 'zod';

export const createFormSchema = (physicalCap?: number) => {
	const roomsRequestedSchema = physicalCap
		? z.coerce
				.number()
				.positive({ message: 'Rooms requested must be positive.' })
				.max(physicalCap, {
					message: `Rooms requested cannot exceed hotel capacity of ${physicalCap}.`,
				})
		: z.coerce
				.number()
				.positive({ message: 'Rooms requested must be positive.' });

	return z
		.object({
			adr_fcst_override: z.number().min(-100, {
				message: 'ADR forecast override should be in between -100 to 100.',
			}),
			avg_stay_length: z
				.number()
				.positive({ message: 'Average stay length must be positive.' }),
			check_in: z.string().min(1, { message: 'Check-in date is required.' }),
			check_out: z.string().min(1, { message: 'Check-out date is required.' }),
			commission: z
				.number()
				.min(0, { message: 'Commission cannot be negative.' }),
			comp_rooms: z.coerce
				.number()
				.int()
				.min(0, { message: 'Comp rooms cannot be negative.' })
				.optional(),
			direct_var_opex: z.coerce.number().min(0, {
				message: 'Direct variable OPEX cannot be negative.',
			}),
			f_and_b_profit: z.coerce
				.number()
				.min(0, { message: 'F&B profit cannot be negative.' }),
			group_name: z.string().min(2, {
				message: 'Group name is required and must be at least 2 characters.',
			}),
			meeting_space_benefit: z.coerce.number().min(0, {
				message: 'Meeting space benefit cannot be negative.',
			}),
			occ_fcst_override: z.coerce.number().min(-100, {
				message:
					'Occupancy forecast override should be in between -100 to 100.',
			}),

			planners_adv_points: z.coerce.number().min(0, {
				message: "Planner's advantage points cannot be negative.",
			}),
			profit_margin: z.coerce
				.number()
				.min(0, { message: 'Profit margin cannot be negative.' }),
			rate_requested: z.coerce
				.number()
				.positive({ message: 'Rate requested must be positive.' }),
			rebate: z.number().min(0, { message: 'Rebate cannot be negative.' }),
			rooms_requested: roomsRequestedSchema,
			wash_factor: z
				.number()
				.min(0, { message: 'Wash factor cannot be negative.' }),
		})
		.refine(
			(data) => {
				const checkIn = parseISO(data.check_in);
				const checkOut = parseISO(data.check_out);
				return checkOut >= checkIn;
			},
			{
				message: 'Check-out date must be on or after check-in date',
				path: ['check_out'],
			},
		);
};

export const FormSchema = createFormSchema();
